import _JSON$stringify from "@babel/runtime-corejs2/core-js/json/stringify";
let state = {};
try {
  state = {
    log: JSON.parse(window.localStorage['log'] || '[]'),
    transactionIndex: JSON.parse(window.localStorage['transactionIndex'] || '[]'),
    payment_order: JSON.parse(window.localStorage['payment_order'] || '[]'),
    statistic: JSON.parse(window.localStorage['statistic'] || '[]'),
    taskManagerIndex: JSON.parse(window.localStorage['taskManagerIndex'] || '[]'),
    userManagerIndex: JSON.parse(window.localStorage['userManagerIndex'] || '[]'),
    data: JSON.parse(window.localStorage['sortData'] || '{}')
  };
} catch (e) {
  console.log(e);
}
const mutations = {
  CHANGE: (state, {
    key,
    value
  }) => {
    if (state.hasOwnProperty(key)) {
      state[key] = value;
      window.localStorage[key] = _JSON$stringify(value);
    }
  },
  UPDATE: (state, {
    key,
    value
  }) => {
    state.data[key] = value;
    window.localStorage['sortData'] = _JSON$stringify(state.data);
  }
};
const actions = {
  change({
    commit
  }, data) {
    commit('CHANGE', data);
  },
  update({
    commit
  }, data) {
    commit('UPDATE', data);
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};